
// Setup the namespace for this logic
var clearanceHandling = clearanceHandling || {};


clearanceHandling.initialize = function() {
	ap.consoleInfo("clearanceHandling initialize!");

	var element = document.getElementById("CustomerNumber");
	if (element) {
		ap.registerEvent(element, 'change', clearanceHandling.onChangeCustomerNumber);
	}

	
	var clearanceHandlingPickerObj = searchResultPicker.getSearchResultPicker("ClearancePicker");
	if (clearanceHandlingPickerObj) {
		
		clearanceHandlingPickerObj.customSearchResultPickerSelectResult = function(picker, resultIndex, resultNameValues) {
			ap.consoleInfo("clearanceHandling.customSearchResultPickerSelectResult called!");
			
			page.customerNumberDisabled = "true";
		
			// If the selected record was allowQuote='Q' then we only copy in SOME values from the server, 
			//   and return false from this function
			var allowQuote = "";
			for (name in resultNameValues) {
				if (name=="ClearanceAllowQuote") {
					allowQuote = resultNameValues[name];
					if (!allowQuote)
						allowQuote = "";
					break;
				}
			}
			if (allowQuote=="Q") {
				for (name in resultNameValues) {
					if (name=="ClearanceAllowQuote" || name=="CustomerNumber" || name=="ApplicantName" ||
							name=="CustomerNumberHidden" || name=="ApplicantRecordU2Version" ||
							name=="ApplicantRecordNeedsProductGroup" || 
							name=="ClearancePicker-ResultList" || name=="ClearanceStatus" || 
							name=="PhoneNumberMatchFound") {
						var field = page.getField(name);
						if (field) {
							var value = resultNameValues[name];
							if (!value)
								value = "";
							if (field.getValue() != value)
								field.setValue(value);
						}
					}
				}
				return false;
			}
		
			// Selected applicant record was "D" or "QR"
			return true;
		};
	}
	
};
	

clearanceHandling.onChangeCustomerNumber = function() {
	var fieldDisabled = page.customerNumberDisabled;
	if (fieldDisabled!=null)
		return;
	var element = document.getElementById("CustomerNumber");
	if(element) {
		var fieldId = element.id;
		page.getField(fieldId).makeIntraPageDTRRequest();
	}
};
